import {useSearchParams} from "react-router-dom";
import {CardShopRepository} from "../Repository/CardShopRepository";
import {BASE_URL, BASE_URL_API} from "../Const";
import {PrintUtils} from "../utils/PrintUtils";
import Swal from "sweetalert2";

export default function PaymentProvider() {

    const [searchParams, setSearchParams] = useSearchParams();

    console.log(searchParams)
    const searchTerm = searchParams.get('status');
    const paymentMetaId = searchParams.get('payment_meta_id');

    if (searchTerm === "completed") {
        CardShopRepository.deleteAll()
    }


    // دریافت لینک از لوکال استوریج
    const localRedirectUrl = localStorage.getItem('redirect_url');

    // بررسی شرط و انتقال
    if (localRedirectUrl) {
        fetch(BASE_URL_API + "order-detail?payment_meta_id=" + paymentMetaId, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        })
            .then((response) => response.json())
            .then(
                (results) => {
                    if (results.code === "200" || results.code === 200) {
                        console.log("✅ Confirm Response:", results);

                        PrintUtils.handleSilentPrint(results.data.data).then(r =>{
                            window.location.replace(localRedirectUrl);
                        });

                    }else {
                        Swal.fire({
                            icon: "error",
                            title: "نا موفق",
                            text: "خطا در دریافت اطلاعات! مجددا تلاش کنید."+results,
                            allowOutsideClick: false, // جلوگیری از بسته شدن با کلیک بیرون کادر
                            allowEscapeKey: false     // جلوگیری از بسته شدن با دکمه Esc
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.replace(localRedirectUrl);
                            }
                        });
                    }
                },
                (error) => {
                    console.log("error");
                    Swal.fire({
                        icon: "error",
                        title: "نا موفق",
                        text: "خطا در دریافت اطلاعات! مجددا تلاش کنید."+error,
                        allowOutsideClick: false, // جلوگیری از بسته شدن با کلیک بیرون کادر
                        allowEscapeKey: false     // جلوگیری از بسته شدن با دکمه Esc
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.replace(localRedirectUrl);
                        }
                    });
                }
            );
    } else {
        window.location.replace(BASE_URL + 'order');
    }
}
